import defaultState from '../default';

const dark = (params) => defaultState.dark(params);

export default dark;
